import styled from 'styled-components';

export const ReturnWrapper = styled.div`
  margin: 48px auto;
  text-align: center;
`;

export const Heading = styled.h2``;

export const Content = styled.p`
  line-height: 1.5;
`;
